import React, { useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import ProductCard from '../../Component/ProductCard/ProductCard';
import Spinner from '../../Component/Spinner/Spinner';
import { AuthContext } from '../../Context/UseContext';
import useScrollToTop from '../../hooks/useScrollToTop';
import useTitle from '../../hooks/useTitle';

const Laptop = () => {
    const { id = "all" } = useParams();
    const { user, loading } = useContext(AuthContext);
    
    useScrollToTop();
    useTitle("Shop Laptop");

    const {
        data: products = [],
        isLoading,
        refetch,
    } = useQuery({
        queryKey: ["products"],
        queryFn: async () => {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/category/${id}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );
            const data = await res.json();
            return data;
        },
    });

    useEffect(() => {
        refetch();
    }, [id, refetch, user]);

    if (isLoading || loading ) {
        return <Spinner />;
    }

    return (
        <>
            <div className="grid3">
                {products?.map((phone) => (
                    <ProductCard
                        key={phone._id}
                        product={phone}
                    />
                ))}
            </div>
        </>
    );
};

export default Laptop;